<template>
    <div class="subscribe_tag">
        <section class="header-wrapper">
            <p v-if="!isSelf" class="subscribe-title">他的订阅</p>
            <el-input
                ref="labelInput"
                class="label-input"
                placeholder="请输入标签名称，回车结束"
                v-model="searchInputVal"
                @change="handleInputSearch">
                <template slot="suffix">
                    <span v-if="searchInputVal" @click="handleInputClear" class="close-icon"></span>
                    <span v-else class="search-icon"></span>
                </template>
            </el-input>
            <ul class="sort-list" v-if="isSelf">
                <li
                    v-for="(item, index) in sortList"
                    :key="index"
                    :class="{'active': sortType === item.sort }"
                    @click="onSwitchSort(item)">
                    {{ item.value }}
                </li>
            </ul>
        </section>
        <section class="table-wrapper" v-loading="isLoading">
            <table cellpadding="0" cellspacing="0">
                <thead>
                    <th width="580">标签名称</th>
                    <th width="200">订阅数量</th>
                    <th width="170">引用量</th>
                    <th>操作</th>
                </thead>
                <tbody v-if="labelList.length">
                    <tr v-for="(rowData, index) in labelList" :key="index">
                        <td>
                            <span class="td-tag">{{ rowData.title }}</span>
                        </td>
                        <td>{{ rowData.subscribe_count || 0 }}</td>
                        <td>{{ rowData.nums || 0 }}</td>
                        <td>
                            <span
                                v-loading="rowData.loading"
                                :class="['td-operate', {'is-sub': !rowData.is_subscribe}]"
                                @click="toggleSubscribe(rowData)">
                                {{ rowData.is_subscribe ? '取消订阅' : '订阅' }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-wrapper" v-if="labelList.length">
                <p class="total-num">{{ '共计' + total + '条' }}</p>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="total"
                    layout="sizes, slot, prev, pager, next">
                    <!-- 空格占位slot -->
                    <div class="empty-div"></div>
                </el-pagination>
            </div>
            <div v-else class="content-empty">
                <img src="../../images/personal_center/data-null.png" alt="" />
                <p>暂无数据</p>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        userId: {
            type: [String, Number]
        },
        isLogin: {
            type: Boolean,
            default: false
        },
        isSelf: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            searchInputVal: '',
            labelList: [],
            isLoading: true,
            total: 10,
            pageSize: 10,
            currentPage: 1,
            sortType: '-subscriber',
            sortList: [
                { value: '已订阅', sort: '-subscriber' },
                { value: '引用量', sort: '-quote' },
                { value: '订阅量', sort: '-subscribe' }
            ]
        }
    },
    watch: {
        sortType: {
            handler (val) {
                window.scrollTo(0, 0)
                this.getLabelList()
            }
        },
        userId: {
            handler (val) {
                if (val) {
                    this.getLabelList()
                } else {
                    this.isLoading = false
                }
            },
            immediate: true
        }
    },
    methods: {
        // 获取标签列表
        async getLabelList () {
            try {
                this.isLoading = true
                const params = {
                    'page': this.currentPage,
                    'page_size': this.pageSize,
                    'title': this.searchInputVal || undefined
                }
                if (this.sortType === '-subscriber') {
                    params.subscriber = this.userId
                } else {
                    params.ordering = this.sortType
                }
                await axios.get(myUrl + 'forum/tags/', { params }).then(res => {
                    const resp = res.data
                    if (!resp.result) return
                    this.total = resp.data.count
                    this.labelList = resp.data.results.map(row => {
                        this.$set(row, 'loading', false)
                        return row
                    })
                })
            } catch (error) {
                console.warn(error)
            } finally {
                this.isLoading = false
            }
        },
        // 订阅/取消订阅
        async toggleSubscribe (row) {
            try {
                if (!this.isLogin) {
                    axios.get(myUrl + 'login/test/')
                    return
                }
                row.loading = true
                await axios.post(myUrl + `forum/tags/${row.id}/${row.is_subscribe ? 'unsubscribe' : 'subscribe'}/`).then(res => {
                    if (!res.data.result) return
                    row.is_subscribe = !row.is_subscribe
                    if (row.is_subscribe) {
                        row.subscribe_count++
                    } else {
                        row.subscribe_count--
                    }
                    this.$message({
                        message: row.is_subscribe ? '订阅成功！' : '取消订阅成功！',
                        type: 'success'
                    })
                })
            } catch (error) {
                console.warn(error)
            } finally {
                row.loading = false
            }
        },
        // 输入框清空
        handleInputClear () {
            this.searchInputVal = ''
            this.currentPage = 1
            this.pageSize = 10
            this.getLabelList()
        },
        // 输入框搜索标签
        handleInputSearch (val) {
            this.currentPage = 1
            this.pageSize = 10
            this.getLabelList()
            this.$refs.labelInput.blur()
        },
        // 设置每页多少条
        handleSizeChange (val) {
            this.pageSize = val
            this.currentPage = 1
            this.getLabelList()
        },
        // 设置多少页
        handleCurrentChange (val) {
            this.currentPage = val
            this.getLabelList()
        },
        // 切换排序类型
        onSwitchSort (item) {
            this.sortType = item.sort
        }
    }
}
</script>

<style lang="scss">
    // 修改分页样式
    .pagination-wrapper {
        height: 34px;
        display: flex;
        align-items: center;
        margin-top: 22px;
        .total-num {
            color: #63656e;
            font-size: 12px;
            font-weight: normal;
        }
        .el-pagination {
            flex: 1;
            display: flex;
            align-items: center;
            padding: 0;
            .el-pagination__sizes {
                height: 32px;
                margin-left: 10px;
                .el-input {
                    width: 80px;
                    height: 32px;
                    .el-input__inner {
                        padding: 0 15px 0 0;
                        height: 100%;
                        font-size: 12px;
                        &:hover, &:focus {
                            border-color: #3a84ff;
                        }
                    }
                    &.is-focus {
                        .el-input__suffix {
                            top: 3px;
                        }
                        .el-input__inner {
                            border-color: #3a84ff;
                        }
                    }
                }
                .el-icon-arrow-up {
                    font-size: 16px;
                    color: #63656e;
                    font-weight: 700;
                }
            }
            .empty-div {
                flex: 1;
            }
            .btn-prev, .number, .more, .btn-next {
                min-width: 32px;
                height: 32px;
                line-height: 30px;
                text-align: center;
                padding: 0;
                border-radius: 2px;
                margin-right: 4px;
                border: 1px solid #c4c6cc;
                color: #63656e;
            }
            .btn-next {
                margin-right: 0;
            }
            .btn-prev, .btn-next {
                &:hover {
                    color: #3a84ff;
                    border-color: #3a84ff;
                }
                &:disabled {
                    border-color: #dcdee5;
                    color: #c4c6cc;
                    background-color: #fafbfd;
                }
            }
            .el-pager {
                color: #63656e;
                font-weight: normal;
                li:hover, .active {
                    border-color: #3a84ff;
                    color: #3a84ff;
                }
            }
            
        }
    }
    .el-scrollbar {
        .el-select-dropdown__item {
            font-weight: normal;
            font-size: 12px;
            color: #63656e;
            &.selected {
                color: #3a84ff;
                background-color: #f4f6fa;
            }
            &:hover {
                background-color: #eaf3ff;
            }
        }
    }
    .label-input {
        width: 240px;
        height: 32px;
        font-size: 12px;
        position: relative;
        .el-input__inner {
            height: 100%;
            border: 1px solid #c4c6cc;
            border-radius: 3px;
            padding: 0 30px 0 10px;
            &:focus-within {
                border-color: #3a84ff;
            }
        }
        .el-input__suffix {
            position: absolute;
            top: 0;
            right: 10px;
            padding-top: 8px;
        }
        .search-icon, .close-icon {
            height: 14px;
            width: 14px;
            display: inline-block;
            background: url('../../images/community/search.png');
            background-size: 100% 100%;
        }
        .close-icon {
            cursor: pointer;
            height: 16px;
            width: 16px;
            background: url('../../images/community/close-circle-shape.png');
            background-size: 100% 100%;
            &:hover {
                background: url('../../images/community/close-circle-shape2.png');
                background-size: 100% 100%;
            }
        }
    }
    .td-operate {
        .el-loading-spinner {
            margin-top: -10px;
            .circular {
                height: 20px;
                width: 20px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .subscribe_tag {
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        padding: 24px;
        .header-wrapper {
            margin-bottom: 13px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .subscribe-title {
                color: #63656e;
            }
            .sort-list {
                flex-shrink: 0;
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #979ba5;
                >li {
                    margin-left: 20px;
                    cursor: pointer;
                    position: relative;
                    &.active,
                    &:hover {
                        color: #313238;
                    }
                    &:not(:first-child)::before {
                        content: '';
                        width: 1px;
                        height: 12px;
                        position: absolute;
                        top: 3px;
                        left: -10px;
                        background: #979ba5;
                    }
                }
                
            }
        }
        .table-wrapper {
            min-height: 320px;
            table {
                color: #63656e;
                font-size: 12px;
                width: 100%;
            }
            thead {
                height: 42px;
                background: #f0f1f5;
            }
            tbody tr {
                height: 46px;
                border-bottom: 1px solid #dcdee5;
            }
            th, td {
                padding-left: 16px;
                text-align: left;
            }
            .td-tag {
                padding: 3px 11px;
                background: #fafbfd;
                border: 1px solid rgba(151,155,165,0.30);
                border-radius: 3px;
            }
            .td-operate {
                width: 86px;
                height: 26px;
                display: inline-block;
                background: #fff;
                border: 1px solid #c4c6cc;
                border-radius: 2px;
                text-align: center;
                line-height: 24px;
                cursor: pointer;
                &:hover {
                    border-color: #979ba5;
                }
                &.is-sub {
                    background: #3a84ff;
                    border-color: #3a84ff;
                    color: #fff;
                    &:hover {
                        background: #699df4;
                        border-color: #699df4;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// subscribe_tag.vue?5fd57020